import * as React from 'react'
// import ResponsiveAdsContainer from '../ResponsiveAdsContainer/ResponsiveAdsContainer'
// import areAdsAllowed from '../../../services/ads/areAdsAllowed'

export default ({ id, ...etcProps }) => {
  //React.useEffect(() => {
  //  window.queueScript(
  //    () => {
  //      window.innity_adZoneAsync.display(
  //        '5a9542c773018268fc6271f7afeea969',
  //        '91044',
  //        {
  //          target: `${id}_desktop`,
  //        },
  //      )
  //    },
  //    () => areAdsAllowed(),
  //  )
  //
  //  window.queueScript(
  //    () => {
  //      window.innity_adZoneAsync.display(
  //        '5a9542c773018268fc6271f7afeea969',
  //        '91047',
  //        {
  //          target: `${id}_mobile`,
  //        },
  //      )
  //    },
  //    () => areAdsAllowed(),
  //  )
  //}, [id])
  //
  //if (areAdsAllowed() && id !== null) {
  //  return (
  //    <ResponsiveAdsContainer
  //      desktop={
  //        <div {...etcProps} id={`${id}_desktop`} key={`${id}_desktop`} />
  //      }
  //      mobile={<div {...etcProps} id={`${id}_mobile`} key={`${id}_mobile`} />}
  //    />
  //  )
  //}

  return <div />
}
